const mask = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {},
}

export default mask
